import React from 'react'

const TableLoader = () => {
    return (
        <div className="w-auto mx-auto mt-5 rounded-t-2xl">
            <div className="overflow-x-auto rounded-t-2xl">
                <table className="w-full text-sm text-left rounded-t-2xl">
                    <thead className="text-md tracking-wide text-navy-900 uppercase bg-[#e0ced7]">
                        <tr className='animate-pulse'>
                            <th className="px-5 py-6"></th>
                            <th className="px-5 py-6"></th>
                            <th className="px-5 py-6"></th>
                            <th className="px-5 py-6"></th>
                            <th className="px-5 py-6"></th>
                            <th className="px-5 py-6"></th>
                            <th className="px-5 py-6"></th>
                            <th className="px-5 py-6"></th>

                        </tr>
                    </thead>
                    <tbody>
                        {[...Array(5)].map((_, index) => (
                            <tr key={index} className="bg-white text-md tracking-wide text-gray-700 animate-pulse">
                                <td className="px-6 py-4 border border-[#ddd9db] whitespace-nowrap">
                                    <div className="h-4 w-4 bg-gray-300 rounded"></div>
                                </td>
                                <td className="px-6 py-4 border border-[#ddd9db] whitespace-nowrap">
                                    <div className="h-4 w-20 bg-gray-300 rounded"></div>
                                </td>
                                <td className="px-6 py-4 border border-[#ddd9db] whitespace-nowrap">
                                    <div className="flex items-center">
                                        {/* <div className="w-10 h-10 bg-gray-300 rounded-full"></div> */}
                                        <div className="ml-4 h-4 w-24 bg-gray-300 rounded"></div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 border border-[#ddd9db] whitespace-nowrap">
                                    <div className="flex items-center">
                                        {/* <div className="w-10 h-10 bg-gray-300 rounded-full"></div> */}
                                        <div className="ml-4 h-4 w-24 bg-gray-300 rounded"></div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 border border-[#ddd9db] whitespace-nowrap">
                                    <div className="h-4 w-16 bg-gray-300 rounded"></div>
                                </td>
                                <td className="px-6 py-4 border border-[#ddd9db] whitespace-nowrap">
                                    <div className="h-4 w-12 bg-gray-300 rounded"></div>
                                </td>
                                <td className="px-6 py-4 border border-[#ddd9db] whitespace-nowrap">
                                    <div className="h-4 w-12 bg-gray-300 rounded"></div>
                                </td>
                                <td className="px-6 py-4 border border-[#ddd9db] whitespace-nowrap">
                                    <div className="h-4 w-12 bg-gray-300 rounded"></div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default TableLoader